export default __webpack_public_path__ + "static/media/SWT0190.34I-27416_-16476_0.07d577d3.jpg";